<template>
  <div>
     <!-- <el-button type="primary" @click="fh()">返回</el-button> -->
   <el-table
      :data="tableData"
      style="width: 100%;margin-top: 20px;"
      >
     <el-table-column
        fixed
        type="index"
        label="序号"
        width="320">
      </el-table-column>
      <el-table-column
        prop="fileName"
        label="导出内容"
        width="320">
      </el-table-column>
      <el-table-column
        label="导出时间"
        width="320">
        <template slot-scope="scope">
          {{ setTime(scope.row.updateAt) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作账号"
        width="320">
        <template slot-scope="scope">
         {{ scope.row.uid}}
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        width="320">
        <template slot-scope="scope">
          <span style="color:red" v-if="scope.row.url == ''">生成中</span>
          <span style="color:#409EFF" v-else @click="xia(scope.row.url)">下载</span>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
          style="float: right;margin-top: 15px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage1"
          :page-sizes="[20]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1">
        </el-pagination>
  </div>
</template>
<script>
import { rescuesaleexportlist } from '@/views/axios/api.js'
export default {
data() {
return {
      tableData:[{}],
      total1:0,
      currentPage1:1,
      count:20,
      start:0,
}
},
methods:{
  setTime(ts) {
			if (ts == null) return '';
  var d = new Date(ts); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = d.getFullYear() + "-";
  var M = (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) + "-";
  var D = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
  var h = d.getHours() < 10 ? '0' + d.getHours() + ":" : d.getHours() + ":";
  var m = d.getMinutes() < 10 ? '0' + d.getMinutes() + ":" : d.getMinutes() + ":";
  var s = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
  // console.log(Y +"-" + M + "-" +D +"-"+ h +"-"+ m +"-"+ s)
  if (d.getHours() == 0 && d.getMinutes() == 0 && d.getSeconds() == 0) {
    return Y + M + D;
  }
  return Y + M + D + ' ' + h + m + s;
			},
  xia(url) {
    window.location = url
  },
  fh() {
    this.$router.push({
					path:'/BusinessStatistics'
				})
  },
  handleSizeChange(val) {
       this.eachPage = val
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        
        this.start = (val-1) * this.eachPage;
        this.getdata()
      },
      getdata() {
        var obj = {
          type:'3', //分成记录 1
          start:this.start,
          count:this.count,
          token:JSON.parse(window.localStorage.getItem("data")).data
        }
    rescuesaleexportlist(obj).then((res)=>{
      this.tableData = res.data.obj
      this.total1 = res.data.total
      console.log(res)
    })
  
      }
},
created() {
  this.getdata()
}
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/cmd_center/star/Exportrecords.vue